import { Link } from "react-router-dom";
import { PageHeader } from "../../components/ui";

const REPORTS = [
  {
    to: "/reports/general-ledger",
    title: "General Ledger",
    desc: "Every posted transaction for an account.",
  },
  {
    to: "/reports/cash-flow",
    title: "Cash Flow",
    desc: "Recorded cash coming in and going out, with opening and closing balances.",
  },
  {
    to: "/reports/profit-and-loss",
    title: "Profit & Loss",
    desc: "Income and expenses over a period — your net income.",
  },
  {
    to: "/reports/balance-sheet",
    title: "Balance Sheet",
    desc: "Assets, liabilities and equity as of a date.",
  },
  {
    to: "/reports/trial-balance",
    title: "Trial Balance",
    desc: "Debit and credit totals for every account.",
  },
  {
    to: "/reports/ar-aging",
    title: "A/R Aging Summary",
    desc: "Outstanding customer balances by age.",
  },
  {
    to: "/reports/ap-aging",
    title: "A/P Aging Summary",
    desc: "What you owe vendors, bucketed by age.",
  },
  {to:'/reports/workspace',title:'Financial reporting workspace',desc:'Comparisons, monthly results, cash flow, supporting schedules, investor packages and planning.'},
];

export default function ReportsIndex() {
  return (
    <div>
      <PageHeader title="Reports" subtitle="Financial statements and account analysis" />
      <nav aria-label="Available reports" className="overflow-hidden rounded-xl border border-gray-200 bg-white">
        <ul className="divide-y divide-gray-200">
          {REPORTS.map((r) => (
            <li key={r.to}>
              <Link to={r.to} className="group flex items-center gap-4 px-4 py-3 transition hover:bg-gray-50 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-2px] focus-visible:outline-brand-600 sm:px-5">
                <div className="min-w-0 flex-1 sm:grid sm:grid-cols-[15rem_1fr] sm:items-center sm:gap-5">
                  <h2 className="text-base font-semibold text-gray-900 group-hover:text-brand-700">{r.title}</h2>
                  <p className="mt-1 text-sm text-gray-600 sm:mt-0">{r.desc}</p>
                </div>
                <span aria-hidden="true" className="shrink-0 text-lg text-brand-600">→</span>
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}
